import { CircularProgress, Grid, Icon, makeStyles, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DisplayText from '../../../../components/Texts/DisplayText';
import { onGetCatalogs } from '../../../../shared/utility';
import { request_subcategories } from '../requests';


const SearchSubcategories = ({onAddItem, existingItems, onAddProductItem, content, product_categories}) => {

    //console.log(product_categories)
    

    const classes = useStyles()
    const add_register = content.add_register

    const [loading, setLoading] = useState(false)
    const [options, setOptions] = useState([add_register]);
    const [value, setValue] = useState(null)
  
    const onChange = (e, item) => {
        if(item){
            if(item.type === 'add'){
                console.log('agregar')
                onAddItem()
                setValue({value:-1, label:''})
                return
            }else{
                setValue(item)
                onAddProductItem(item.value)
                setValue({value:-1, label:''})
            }
        }else{
            setValue(null)
        }      
    }

    const onInputChange = async(e) => {
        if(!e || e.target.value === 0) return
        try {
            setLoading(true)
            const categories = product_categories.map((item)=>{
                return {"field":"category_id","operator":"=","value":`${item.category_id}`}
            })
            // console.log('hola')
            // console.log(categories)
            let filter = {"OR":categories}
            filter = encodeURIComponent(JSON.stringify(filter))
            const params = `?&filter=${filter}`
            let _subcategories = await request_subcategories(params)
            console.log(_subcategories)
            const subcategories = [..._subcategories.subcategorys_data]   
            //console.log(categories)    
            const opt = subcategories.map((item)=>{
                let ex= true
                for (let index = 0; index < existingItems.length; index++) {
                    if (item.id_sub_category === existingItems[index].sub_category_id) ex = false
                }
                if(ex){
                    return item
                }else{
                    return null
                }
            })
            let final = []
            opt.forEach(el => {
                if(el !== null) final.push(el)
            })
            const catalogs = onGetCatalogs(final, 'id_sub_category', 'name')
            setOptions([add_register, ...catalogs])    
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }


    return (  
        <div>
            <Autocomplete
                id="search-user-id"
                getOptionLabel={(option) => option.label}
                options={options}
                loading={loading} fullWidth
                value={value}
                onChange={onChange}
                onInputChange={onInputChange}
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label={content.placeholder}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                        <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                        ),
                    }}
                    />
                )}
                renderOption={(option, {selected}) => {
                    if(option.type === 'add'){
                        return(
                            <React.Fragment>
                                <div >
                                    <Grid container alignItems='center'>
                                        <Grid item><Icon color='primary' className={classes.add_icon}>add</Icon></Grid>
                                        <Grid item xs><DisplayText>{option.label}</DisplayText></Grid>
                                    </Grid>
                                    
                                </div>
                            </React.Fragment>
                        )
                    }
                    return (
                        <React.Fragment>
                            <div>
                                <DisplayText>{option.label}</DisplayText>
                            </div>
                        </React.Fragment>
                    )
                }}
            />
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    add_icon:{
        background:theme.palette.primary.main,
        color:'white',
        borderRadius:'50%',
        marginTop:6, marginRight:8
    }
}))
 
export default SearchSubcategories;